module.exports = __webpack_public_path__ + "static/media/menu_vehicle.42d2b57d.svg";